module.exports = __webpack_public_path__ + "img/carousel-1.14997f8.png";